/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

import Pusher from 'pusher-js';

@Injectable()
export class PusherService {
  public pusherClient: Pusher;

  public subject_root: Subject<string> = new Subject<string>();
  public subject_monitorUserLogins: Subject<{ email: string }> = new Subject<{ email: string }>();
  public subject_monitorReports = new Subject;
  public subject_monitorPayrollFeeds = new Subject;
  public subject_monitorPayrollMessages = new Subject;
  public subject_monitorPayrollExports = new Subject;
  public subject_monitorBscMessages = new Subject;
  public subject_monitorBscExports = new Subject;
  public subject_monitorSubmissions = new Subject;

  public channel_authentication;
  public channel_reports;
  public channel_payroll;
  public channel_bsc;
  public channel_submission;

  constructor() {
    this.pusherClient = new Pusher('319b9fea774b9d43b865', { cluster: 'ap1', forceTLS: true, disableStats: true });
  }

  monitorRoot(): Observable<string> {
    return this.subject_root.asObservable();
  }
  parseRoot(command) { this.subject_root.next(command) }

  monitorUserLogins(): Observable<{ email: string }> {
    return this.subject_monitorUserLogins.asObservable();
  }

  monitorReports(): Observable<{}> {
    return this.subject_monitorReports.asObservable();
  }

  monitorPayrollMessages(): Observable<{}> {
    return this.subject_monitorPayrollMessages.asObservable();
  }

  monitorPayrollFeeds(): Observable<{}> {
    return this.subject_monitorPayrollFeeds.asObservable();
  }

  monitorPayrollExports(): Observable<{}> {
    return this.subject_monitorPayrollExports.asObservable();
  }

  monitorSubmissions(): Observable<{}> {
    return this.subject_monitorSubmissions.asObservable();
  } 

  monitorBscMessages(): Observable<{}> {
    return this.subject_monitorBscMessages.asObservable();
  }

  monitorBscExports(): Observable<{}> {
    return this.subject_monitorBscExports.asObservable();
  }
}